var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6665 10C1.6665 10 4.99984 4.16669 9.99984 4.16669C14.9998 4.16669 18.3332 10 18.3332 10C18.3332 10 14.9998 15.8334 9.99984 15.8334C4.99984 15.8334 1.6665 10 1.6665 10Z",
    stroke: "#009688",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 2.5,
    stroke: "#009688",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.dd7180fc3261400d17f9363634cdc6e8.svg";
export { ForwardRef as ReactComponent };